import { ApolloProvider } from '@apollo/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'antd/dist/antd.css';
import Schema from 'async-validator';
import Amplify from 'aws-amplify';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
import './App.css';
import './Global/global.scss';
import { client } from './apolloConfig';
import config from './aws-exports';
import { AvatarProvider } from './context/AvatarContext';
import { CashBalanceProvider } from './context/CashBalanceContext';
import { SessionProvider } from './context/SessionProvider';
import './i18nextConf';
import './index.css';
import { persistor, store } from './redux';
import reportWebVitals from './reportWebVitals';
import AppLayout from './router/layout';
import { responsiveTheme } from './theme/theme';

Amplify.configure(config);
Schema.warning = () => {};

Sentry.init({
  enabled: process.env.NODE_ENV !== 'development',
  dsn: process.env.REACT_APP_SENTRY,
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 1.0,
});

const queryClient = new QueryClient();
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <ApolloProvider client={client}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={responsiveTheme}>
            <CssBaseline />
            <BrowserRouter>
              <SessionProvider>
                <AvatarProvider>
                  <CashBalanceProvider>
                    <AppLayout />
                    <Toaster />
                  </CashBalanceProvider>
                </AvatarProvider>
              </SessionProvider>
            </BrowserRouter>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </ApolloProvider>
    <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
  </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
